import Svg, { Circle, G, Line, Path, Rect } from 'react-native-svg'

//FIXME: update with real SVG's
export const NoTransaction = ({ color = '#214796', textColor = '#2a4e9a' }: any) => {
  return (
    <Svg width="195.614" height="121.308" viewBox="0 0 195.614 121.308">
      <G id="No_transactions" data-name="No transactions" transform="translate(-914.634 -1059.702)">
        <G id="Group_1361" data-name="Group 1361" transform="translate(914.634 1108.789)">
          <G id="Group_872" data-name="Group 872" transform="translate(0 0)">
            <G
              id="Rectangle_995"
              data-name="Rectangle 995"
              transform="translate(180.514 71.095) rotate(90)"
              fill="none"
              stroke={color}
              strokeWidth="4">
              <Rect id="fill" width="1" height="159.939" rx="0.5" stroke="none" />
              <Path
                d="M0,2h1M2,0v159.93882751464844M1,157.93882751464844h-1M-1,159.93882751464844v-159.93882751464844"
                fill="none"
                clipPath="url(#clip)"
              />
            </G>
            <G
              id="Rectangle_1003"
              data-name="Rectangle 1003"
              transform="translate(195.614 71.095) rotate(90)"
              fill="none"
              stroke={color}
              strokeWidth="2">
              <Rect id="fill-2" width="1" height="8.797" rx="0.5" stroke="none" />
              <Path
                d="M0,1h1M1,0v8.797151565551758M1,7.797151565551758h-1M0,8.797151565551758v-8.797151565551758"
                fill="none"
                clipPath="url(#clip-2)"
              />
            </G>
            <G
              id="Rectangle_998"
              data-name="Rectangle 998"
              transform="translate(17.592 71.095) rotate(90)"
              fill="none"
              stroke={color}
              strokeWidth="2">
              <Rect id="fill-3" width="1" height="9.151" rx="0.5" stroke="none" />
              <Path
                d="M0,1h1M1,0v9.150984764099121M1,8.150984764099121h-1M0,9.150984764099121v-9.150984764099121"
                fill="none"
                clipPath="url(#clip-3)"
              />
            </G>
            <G
              id="Rectangle_999"
              data-name="Rectangle 999"
              transform="translate(5.458 71.095) rotate(90)"
              fill="none"
              stroke={color}
              strokeWidth="2">
              <Rect id="fill-4" width="1" height="5.458" rx="0.5" stroke="none" />
              <Path
                d="M0,1h1M1,0v5.45805549621582M1,4.45805549621582h-1M0,5.45805549621582v-5.45805549621582"
                fill="none"
                clipPath="url(#clip-4)"
              />
            </G>
          </G>
        </G>
        <G id="Group_2565" data-name="Group 2565" transform="translate(978.807 1060.202)">
          <Rect
            id="Rectangle_302"
            data-name="Rectangle 302"
            width="68.223"
            height="115.82"
            rx="4"
            transform="translate(0 0)"
            fill="#fff"
          />
          <Rect
            id="Rectangle_1004"
            data-name="Rectangle 1004"
            width="68.223"
            height="120.308"
            rx="8"
            transform="translate(0.421 0)"
            fill="rgba(33,71,150,0.08)"
            stroke={textColor}
            strokeWidth="1"
          />
          <Rect
            id="Rectangle_1005"
            data-name="Rectangle 1005"
            width="11.968"
            height="11.968"
            rx="5.984"
            transform="translate(28.843 98.264)"
            fill="rgba(33,71,150,0.08)"
            stroke={textColor}
            strokeWidth="1"
          />
          <G id="Group_2931" data-name="Group 2931" transform="translate(-5.173 6.586)">
            <G id="Group_2589" data-name="Group 2589" transform="translate(0)">
              <G
                id="Rectangle_1476"
                data-name="Rectangle 1476"
                transform="translate(97.836 25.213) rotate(90)"
                fill="#fff"
                stroke={textColor}
                strokeWidth="1">
                <Rect width="38.706" height="117.836" rx="4" stroke="none" />
                <Rect x="0.5" y="0.5" width="37.706" height="116.836" rx="3.5" fill="none" />
              </G>
              <G
                id="Rectangle_1477"
                data-name="Rectangle 1477"
                transform="translate(97.836 42.213) rotate(90)"
                fill="#fff"
                stroke={textColor}
                strokeWidth="1">
                <Rect width="38.706" height="117.836" rx="4" stroke="none" />
                <Rect x="0.5" y="0.5" width="37.706" height="116.836" rx="3.5" fill="none" />
              </G>
              <G id="Group_2934" data-name="Group 2934">
                <G
                  id="Rectangle_993"
                  data-name="Rectangle 993"
                  transform="translate(105.836 33.702) rotate(90)"
                  fill="#fff"
                  stroke={textColor}
                  strokeWidth="1">
                  <Rect width="38.706" height="133.836" rx="4" stroke="none" />
                  <Rect x="0.5" y="0.5" width="37.706" height="132.836" rx="3.5" fill="none" />
                </G>
                <G id="Group_2932" data-name="Group 2932" transform="translate(66.967 41.134)">
                  <G id="Group_2553" data-name="Group 2553" transform="translate(0 0)">
                    <G id="Group_941" data-name="Group 941" transform="translate(0)">
                      <G id="Group_822" data-name="Group 822" transform="translate(0)">
                        <G
                          id="Ellipse_80"
                          data-name="Ellipse 80"
                          transform="translate(2.568 2.568)"
                          fill="rgba(33,71,150,0.08)"
                          stroke={color}
                          strokeWidth="1">
                          <Circle cx="9.842" cy="9.842" r="9.842" stroke="none" />
                          <Circle cx="9.842" cy="9.842" r="9.342" fill="none" />
                        </G>
                        <G id="code-24px" transform="translate(4.542 4.486)">
                          <Path id="Path_395" data-name="Path 395" d="M0,0H15.6V15.6H0Z" fill="none" />
                        </G>
                        <G id="Group_2575" data-name="Group 2575" transform="translate(9.246 7.615)">
                          <Path
                            id="Path_485"
                            data-name="Path 485"
                            d="M40.81,28.16a3.788,3.788,0,0,1,.78,3.049c-.24,2.02-3.04,1.984-3.04,1.984L42.5,38.549"
                            transform="translate(-37.541 -28.16)"
                            fill="none"
                            stroke={color}
                            strokeWidth="1"
                          />
                          <Path
                            id="Path_486"
                            data-name="Path 486"
                            d="M34.014,26.529h6.614"
                            transform="translate(-34.014 -26.529)"
                            fill="none"
                            stroke={color}
                            strokeLinecap="round"
                            strokeWidth="1"
                          />
                          <Path
                            id="Path_487"
                            data-name="Path 487"
                            d="M34.014,26.529h6.614"
                            transform="translate(-34.014 -24.304)"
                            fill="none"
                            stroke={color}
                            strokeLinecap="round"
                            strokeWidth="1"
                          />
                        </G>
                      </G>
                    </G>
                  </G>
                </G>
                <G id="Group_2933" data-name="Group 2933" transform="translate(0 2.5)">
                  <Line
                    id="Line_38"
                    data-name="Line 38"
                    x2="44"
                    transform="translate(-13.167 45.202)"
                    fill="none"
                    stroke={textColor}
                    strokeLinecap="round"
                    strokeWidth="1"
                  />
                  <Line
                    id="Line_39"
                    data-name="Line 39"
                    x2="14"
                    transform="translate(-13.167 56.202)"
                    fill="none"
                    stroke={textColor}
                    strokeLinecap="round"
                    strokeWidth="1"
                  />
                  <Line
                    id="Line_40"
                    data-name="Line 40"
                    x2="14"
                    transform="translate(4.833 56.202)"
                    fill="none"
                    stroke={textColor}
                    strokeLinecap="round"
                    strokeWidth="1"
                  />
                </G>
              </G>
            </G>
          </G>
        </G>
      </G>
    </Svg>
  )
}
